module.exports = __webpack_public_path__ + "img/blog-11.aeb873c6.webp";